import React from 'react'
import TableComponent from 'components/Table'
import { CreditRowItem } from '../../CreditRowItem'
import { Collapse } from 'antd'

import { MinusSmallIco, PlusSmallIco } from '../../../../../../modules/CustomIcons'
import { useTranslation } from 'react-i18next'

const DeactiveCreditList = (props: any) => {
    const {t} =useTranslation()
  const { Panel } = Collapse
console.log('deactive')
  return (
    <div className={'creditCollapseBox'} style={{ display: "block" }}>
    <Collapse accordion expandIconPosition={'end'} className={'creditCollapse creditCollapseDeactive'} ghost
        expandIcon={() => <div className={'creditCollapse__iconBox'}>
            {props.panel ? <MinusSmallIco /> : <PlusSmallIco />}
        </div>}
        onChange={props.onClosePanel}>
        {/*<div>*/}
        <Panel className={'creditListPanel'} header={t("credits.closedLoans")} key="1" extra={<div className={'line'} />}>
            <TableComponent
                columns={props.columnsData}
                // className="credit-table-panel depositTable"
                className="credit-table depositTable credit-table-panel transfer-table salary-table credit_table deactiveCreditTable creditFixedColumnTable"
                rowClassName={(record, index) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
                data={props.data}
                scroll={{x:1000}}
                pagination={false}
                rowSelection={false}
                onRow={props.onRowPanel}
                pageSize={props.pageSize}
                onChange={props.onChange}
                expandedRowKeys={props.expandedRowKeys}
                onExpand={props.onExpand}
                // ellipsis
                expandable={{
                    expandedRowRender: (record: any) => {
                        return (
                            <CreditRowItem
                                leftItems={record}
                                styleCreditRowColumLeft={{ marginLeft: 80 }}
                                styleCreditRowColum={{ marginLeft: -58 }}
                                handleRowClose={props.handleRowClose}
                                tableData={record} />
                        )
                    },
                    // rowExpandable: record => {            
                    //     if (props.firstRow) {
                    //       return false;
                    //     } else {
                    //       return true;
                    //     }
                    //   },
                    expandRowByClick: true,
                    expandIconColumnIndex: -1,
                    showExpandColumn: false
                    // expandIcon: () => null
                }} />
        </Panel>
        {/*</div>*/}
    </Collapse>
</div>
  )
}
export default DeactiveCreditList